export enum DriveUserRoles {
  ADMIN = 'admin',
  FULL_VIEWER = 'full_viewer'
}

export interface DriveUserRole {
  id: string
  user: string
  role: DriveUserRoles
}
